import './index.scss'
$(".country ul li.active").hover(function() {
  $(this).parent().find(".mes").show();
},(function() {
  $(".country ul li.mes").hide();
})
)